import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { MeetingNotesAutomationDiscoveryFragmentProps } from './MeetingNotesAutomationDiscoveryFragment.tsx';

export const LazyMeetingNotesAutomationDiscoveryFragment: LoadableType<MeetingNotesAutomationDiscoveryFragmentProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-MeetingNotesAutomationDiscoveryFragment" */ './MeetingNotesAutomationDiscoveryFragment.tsx'
				)
			).MeetingNotesAutomationDiscoveryFragment,
	});
